import React, { useState, useEffect } from "react";
import { Link } from "react-router-dom";
import * as moment from "moment";
import { capitalize } from "lodash";
import { Util } from "../../../../../../../../helpers/util";
import "./SavestFlexible.css";
import AutoDebitDetails from "../SavestFixedPlan/AutoDebitDetails";
import { $api } from "../../../../../../../../helpers/$api";

const SavingsSummary = ({ setMenu, automation }) => {
  const { currency } = Util.getCurrency();
  const [hasAccepted, setAccepted] = useState(false);
  const [ovest, setOvest] = useState(0);
  const payload = Util.get("create_flexible_plan");

  useEffect(() => {
    (async () => {
      try {
        const { wallet_balance: ovest } = await $api.user.getBalances();

        setOvest(ovest);
      } catch (error) {
        // error...
      }
    })();
  }, [setOvest]);

  let unit = "days";
  switch (payload.frequency) {
    case "weekly": {
      unit = "weeks";
      break;
    }
    case "monthly": {
      unit = "months";
      break;
    }
    default:
    //...
  }

  return (
    <div className="create-flexible-plan">
      <div className="create-flexible-plan-main">
        <div className="create-flexible-header">
          <h5 className="create-flexible-h5">Saving Summary</h5>
          <p className="create-flexible-p">
            Let’s go over all you have selected, then proceed to saving into
            this plan.
          </p>
        </div>
        <div className="silverplan">
          <h5 className="silverplan-header">Saving Summary</h5>
          <div className="silverplan-flex">
            {/* <div className="investamount">
              <p className="flex-main">:</p>
              <p className="pricetag">{currency}50,000.00</p>
            </div> */}
            <div className="investamount">
              <p className="flex-main">Target Amount:</p>
              <p className="pricetag">
                {currency}
                {Util.formatMoneyNumber(+payload.target_amount)}
              </p>
            </div>
            <div className="investamount">
              <p className="flex-main">Periodic Savings:</p>
              <p className="flex-mini">
                {currency}
                {Util.formatMoneyNumber(+payload.amount_to_save)}
              </p>
            </div>
            <div className="investamount">
              <p className="flex-main">Start Date:</p>
              <p className="flex-mini">
                {moment(payload.start_date).format("DD MMM, YYYY")}
              </p>
            </div>
            <div className="investamount">
              <p className="flex-main">Maturity Date:</p>
              <p className="flex-mini">
                {moment(payload.start_date)
                  .add(Math.round(15), unit)  
                  .format("DD MMM, YYYY")}
              </p>
            </div>
            <div className="investamount">
              <p className="flex-main">Saving Frequency:</p>
              <p className="flex-mini">{capitalize(payload.frequency)}</p>
            </div>

            <div className="investamount">
              <p className="flex-main">Interest Rate:</p>
              <p className="pricetag">7% monthly</p>
            </div>
            <div className="investamount">
              <p className="flex-main">Return Value:</p>
              <p className="pricetag">
                N{Util.formatMoneyNumber(+payload.target_amount * 0.07)}
              </p>
            </div>
            <div className="investamount">
              <p className="flex-main">Savest Type:</p>
              <p className="flex-mini">Flexible</p>
            </div>
            <div className="investamount">
              <p className="flex-mini">Total Payout:</p>
              <p className="pricetag-mini">
                N
                {Util.formatMoneyNumber(
                  +payload.target_amount * 0.07 + +payload.target_amount
                )}
              </p>
            </div>
          </div>
        </div>
        {+payload.automation_status === 0 && (
          <div>
            <div className="switch-account-flex">
              <h5>Your default auto debit account</h5>
              <p onClick={() => setMenu(11)} className="switch-account">
                Switch
              </p>
            </div>
            <AutoDebitDetails data={{ ovest, ...automation }} />
          </div>
        )}
        <div className="flexible-plan-note">
          <p className="flexible-plan-note-p">
            {" "}
            <span>Note:</span> 7% interest is subject to limiting withdrawals to
            twice a month. Withdrawing more than twice a month forfeit interest
            for the month. Withdrawals from Savest can only be made every 15th
            and 30th day of every month.
          </p>
        </div>
        <div className="checkbox-main">
          <input
            type="checkbox"
            name=""
            id=""
            className="checkbox-input"
            checked={hasAccepted}
            onChange={() => setAccepted(!hasAccepted)}
          />
          <label htmlFor="" className="termsandcondition">
            By clicking this, you’ve agreed to
            <Link to="/terms">
              <span> OVest terms and conditions</span>
            </Link>
          </label>
        </div>

        <button
          onClick={() => {
            if (hasAccepted) {
              if (automation) {
                const { payment_method, card_id } = automation;
                payload.automatic_payment_method = payment_method;
                payload.automatic_debit_card_id = card_id;
              }
              Util.set("create_flexible_plan", {
                ...payload,
              });
              setMenu(4);
            }
          }}
          disabled={!hasAccepted}
          className="savest-button mb-2"
        >
          Proceed
        </button>
      </div>
    </div>
  );
};

export default SavingsSummary;
